import { DiscountDivisionState, initialDivisionState } from "./state";
import { ActionType } from "app/pages/DiscountEditor/actionTypes";

export const SET_SELECTED_DIVISIONS = 'discountEditor/divisions/SET_SELECTED_DIVISIONS';


export default function discountDivisionReducer(
  state: DiscountDivisionState = initialDivisionState,
  action: any
): DiscountDivisionState {
  switch (action.type) {
    case SET_SELECTED_DIVISIONS:
      let ids: number[] = [];
      if (Array.isArray(action.ids)) {
        ids = action.ids
          .map((id: any) => {
            if (typeof id === 'number') return id;
            const num = Number(id);
            return isNaN(num) ? null : num;
          })
          .filter((id: any) => id !== null) as number[];
      } else if (action.ids !== null && action.ids !== undefined) {
        const num = typeof action.ids === 'number' ? action.ids : Number(action.ids);
        if (!isNaN(num)) {
          ids = [num];
        }
      }
      
      return { ...state, selectedDivisionIds: ids };
    case ActionType.PageLoaded:
      const divisionFilter = action.discount?.divisionFilter;
      let numericDivisionIds: number[] = [];
      
      if (divisionFilter) {
        if (divisionFilter.divisionId !== undefined && divisionFilter.divisionId !== null) {
          const num = typeof divisionFilter.divisionId === 'number' 
            ? divisionFilter.divisionId 
            : Number(divisionFilter.divisionId);
          if (!isNaN(num) && num > 0) {
            numericDivisionIds = [num];
          }
        }
        else if (divisionFilter.divisionIds !== undefined) {
          const divisionIds = divisionFilter.divisionIds;
          numericDivisionIds = Array.isArray(divisionIds)
            ? divisionIds
                .map((id: any) => {
                  if (typeof id === 'number') return id;
                  const num = Number(id);
                  return isNaN(num) ? null : num;
                })
                .filter((id: any) => id !== null) as number[]
            : [];
        }
      }
      return { ...state, selectedDivisionIds: numericDivisionIds };
    default:
      return state;
  }
}